module.exports = __webpack_public_path__ + "assets/komodo.1da60300.png";